import { CHANGE_RECORDS, RETRIEVE_RECORDS_STARTED } from '../actions/search';

export default function (state = {}, action) {
  switch (action.type) {
  case CHANGE_RECORDS: {
    const { imports, importRequests, meta } = action;
    return { ...state, isFetching: false, imports, importRequests, meta };
  }
  case RETRIEVE_RECORDS_STARTED:
    return { ...state, isFetching: true };
  default:
    return state;
  }
}
